// @flow

import { PoinzApiClient } from '../../api';
import { ROOT } from './config';
import { IUserBankAccount } from './types/bankAccount';

const API_ROOT = `${ROOT}/v2/mobile/bank-accounts`;
const API_ROOT_CAMP = `${ROOT}/v2/camp/bank-accounts`;

const get = (apiClient: PoinzApiClient) => async (): Promise<IUserBankAccount> => {
  const result = await apiClient.get(API_ROOT, {});

  return result.body;
};

const getCampBankAccountById =
  (apiClient: PoinzApiClient) =>
  async (userId: number): Promise<IUserBankAccount> => {
    const result = await apiClient.get(API_ROOT_CAMP, {
      queryParams: { userId }
    });

    return result.body;
  };

const updateCampBankAccount =
  (apiClient: PoinzApiClient) =>
  async (id: number, bankAccount: IUserBankAccount): Promise<IUserBankAccount> => {
    const result = await apiClient.put(`${API_ROOT_CAMP}/${id}`, {
      body: bankAccount
    });

    return result.body;
  };

const create =
  (apiClient: PoinzApiClient) =>
  async (bankAccount: IUserBankAccount): Promise<IUserBankAccount> => {
    const result = await apiClient.post(API_ROOT, {
      body: bankAccount
    });

    return result.body;
  };

const update =
  (apiClient: PoinzApiClient) =>
  async (id: number, bankAccount: IUserBankAccount): Promise<IUserBankAccount> => {
    const result = await apiClient.put(`${API_ROOT}/${id}`, {
      body: bankAccount
    });

    return result.body;
  };

export default (apiClient: PoinzApiClient) => ({
  get: get(apiClient),
  getCampBankAccountById: getCampBankAccountById(apiClient),
  updateCampBankAccount: updateCampBankAccount(apiClient),
  create: create(apiClient),
  update: update(apiClient)
});
